<template>
  <div style="padding: 5px;">
    <!-- <Logo />
    <br /> -->
    <Company />
    <br />
    <ListApp />
  </div>
</template>
<script>
import Logo from "./components/logo";
import Company from "./components/company";
import ListApp from "./components/listApp";
export default {
  components: { Company, ListApp },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="css" scoped></style>
